import React, { useContext } from "react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { OfferStoreContext } from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { observer } from "mobx-react";

import TeamLineups from "./TeamLineups";
import TeamLineupsPage from "./TeamLineupsPage";

export const TeamLineupsSection = observer(function TeamLineupsSection() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	if (store.displayStatisticsGroup === StatisticsGroups.TeamLineups) {
		if (store instanceof AdditionalOfferViewStore) {
			return (
				<ErrorBoundaryWithPropagation componentName="Desktop/TeamLineups.tsx">
					<TeamLineups store={store.teamLineupsStore} />
				</ErrorBoundaryWithPropagation>
			);
		}

		return (
			<ErrorBoundaryWithPropagation componentName="Desktop/TeamLineupsPage.tsx">
				<TeamLineupsPage store={store.teamLineupsStore} />
			</ErrorBoundaryWithPropagation>
		);
	}
	return null;
});
